module.exports = "/_next/static/images/2b49141caa486a61f270bd05130d885f-slide3desktop.jpg";